import GroupBookingSeatSelection from './GroupBookingSeatSelection';

export default GroupBookingSeatSelection;
